import { Feature } from 'ol'
import { Geometry, Point } from 'ol/geom'
import { Vector as VectorSource } from 'ol/source'
import { Vector as VectorLayer } from 'ol/layer'
import { fromLonLat } from 'ol/proj'
import { Style, Icon } from 'ol/style'
import { VesselPositionModel } from '../models/vessel-position-model'
import { VoyageImoModel } from '../models/voyage-imo-model'

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;

// Plots the current ship position for vessel
export class VesselLayer {
    constructor() {
        this._shipShape = this.getShipSvg()

        this._plotVessel = this._plotVessel.bind(this)
    }

    get layer() {
        return this._layer
    }

    async initialize() {
        this._shipVectorSource = new VectorSource({})
        this._layer = new VectorLayer({
            source: this._shipVectorSource,
            visible: true,
            zIndex: 5,
        })

        VesselPositionModel!.addEventListener(
            'position-updated',
            this._plotVessel,
        )
        if (VesselPositionModel!.position) {
            this._plotVessel()
        }
    }

    private _plotVessel() {
        this._shipVectorSource!.clear()
        const projection = (<any>window)['appenv'].projection
        const imoNo = isVesselOnCloud ? VoyageImoModel?.imo :  (<any>window)['appenv'].vesselIMONumber
        const position = VesselPositionModel!.position

        if (
            !position ||
            position.latitude === null ||
            position.longitude === null
        ) {
            return
        }

        const coords = fromLonLat(
            [position.longitude, position.latitude],
            projection,
        )

        const heading =
            position.heading !== null
                ? position.heading
                : position.course !== null
                ? position.course
                : 0

        const rotation = ((heading - 90) * Math.PI) / 180 // Icon needs to be rotated 90 deg to match
        const styles = [
            new Style({
                image: new Icon({
                    opacity: 1,
                    src: this._shipShape,
                    rotation: rotation,
                    rotateWithView: true,
                    anchor: [0.5, 0.5],
                }),
                zIndex: 10,
            }),
        ]

        // TODO - should we handle outdated position? - left out for now

        const shipPoint = new Point(coords)
        const shipFeature = new Feature(shipPoint)
        shipFeature.setStyle(styles)

        shipFeature.set('name', 'Current position')
        shipFeature.set('imoNo', imoNo)
        shipFeature.set('layer', 'vesselLayer')
        this._shipVectorSource!.addFeature(shipFeature)
    }

    private getShipSvg = () => {
        const svg = `
                  <svg width="45" height="21" viewBox="0 0 45 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="path-1-inside-1" fill="white">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M30 20.7808L45 10.7808L30 0.780761L0 0.78076L-8.74228e-07 20.7808L30 20.7808Z"/>
                    </mask>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M30 20.7808L45 10.7808L30 0.780761L0 0.78076L-8.74228e-07 20.7808L30 20.7808Z" fill="#003D6D"/>
                    <path d="M45 10.7808L45.5547 11.6128L46.8028 10.7808L45.5547 9.94871L45 10.7808ZM30 20.7808L30 21.7808L30.3028 21.7808L30.5547 21.6128L30 20.7808ZM30 0.780761L30.5547 -0.0512892L30.3028 -0.219239L30 -0.219239L30 0.780761ZM0 0.78076L4.37114e-08 -0.21924L-1 -0.21924L-1 0.78076L0 0.78076ZM-8.74228e-07 20.7808L-1 20.7808L-1 21.7808L-9.17939e-07 21.7808L-8.74228e-07 20.7808ZM44.4453 9.94871L29.4453 19.9487L30.5547 21.6128L45.5547 11.6128L44.4453 9.94871ZM29.4453 1.61281L44.4453 11.6128L45.5547 9.94871L30.5547 -0.0512892L29.4453 1.61281ZM-4.37114e-08 1.78076L30 1.78076L30 -0.219239L4.37114e-08 -0.21924L-4.37114e-08 1.78076ZM0.999999 20.7808L1 0.78076L-1 0.78076L-1 20.7808L0.999999 20.7808ZM30 19.7808L-8.30516e-07 19.7808L-9.17939e-07 21.7808L30 21.7808L30 19.7808Z" fill="white" mask="url(#path-1-inside-1)"/>
                    </svg>
            `
        return 'data:image/svg+xml;utf8,' + encodeURIComponent(svg)
    }

    private _layer: VectorLayer<VectorSource<Geometry>> | null = null
    private _shipShape: string
    private _shipVectorSource: VectorSource<Geometry> | null = null
}
